import { useState } from 'react';

import styles from './FieldWasChanged.module.scss';

type Props = {
  text: string;
  containerClassName?: string;
};

export const FieldWasChangedIcon = ({ text, containerClassName }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={containerClassName || styles.TooltipIcon}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className={styles.Icon} />
      {isHovered && !!text && <div className={styles.TooltipContentCustom}>{text}</div>}
    </div>
  );
};
